import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductRamService } from '../../../services/product-ram.service';

@Component({
  selector: 'app-view-product-rams',
  templateUrl: './view-product-rams.component.html',
  styleUrls: ['./view-product-rams.component.css'],
  providers:[ProductRamService]
})
export class ViewProductRamsComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  productRam: any = {
    laptops: false,
    consoles: false,
    products: false,
    mobiles: false
  };
  constructor(private productRamService:ProductRamService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getProductRam();
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getProductRam(){
    this.productRamService.get(this.id).subscribe((productRam) => {
      this.productRam = productRam;
    });
  }
  

  saveProductRam(){
    this.parseProductsType();
    if (this.productRam.id == undefined){
      this.productRamService.create(this.returnProductRamProperties(this.productRam))
      .subscribe((productRam) => {
        this.productRamService.get(productRam.id).subscribe((productRam) => {
          this.productRam = productRam;
          this.router.navigate(['/configuration/productrams']);
        });
      });
    }else{
      this.productRamService.update(this.returnProductRamProperties(this.productRam))
      .subscribe((productRam) => {
        this.productRam = productRam;
        this.router.navigate(['/configuration/productrams']);
      });
    }
  }

  returnProductRamProperties(productRam){
    var properties = {
      name: productRam.name,
      product_types: productRam.product_types
    }
    if (productRam.id){
      properties['id'] = productRam.id;
    }
    return properties;
  }

  parseProductsType(){
    this.productRam.product_types = "";
    if(this.productRam.mobiles === true){
      this.productRam.product_types += "1,";
    }
    if(this.productRam.consoles === true){
      this.productRam.product_types += "2,";
    }
    if(this.productRam.products === true){
      this.productRam.product_types += "3,";
    }
    if(this.productRam.laptops === true){
      this.productRam.product_types += "4,";
    }
    this.productRam.product_types = this.productRam.product_types.substring(0,this.productRam.product_types.length - 1);
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-rams/view-product-rams/view-product-rams.component.ts